export default __webpack_public_path__ + "static/media/GESTTitleBackground.fb70ac5d.png";